export default function() {
    return {
        coaching_tracks: [],
        drop_ins: [],
        config_api: {},
        quotes: [],
        upcoming_event: {},
        survey_cards: [],
    }
}
